import React from "react";
import { createRoot } from "react-dom/client";
import "@tecma/ds/styles/global.css";
import "@tecma/ds/accordion/style.css";
import "@tecma/ds/alert/style.css";
import "@tecma/ds/avatar/style.css";
import "@tecma/ds/button/style.css";
import "@tecma/ds/card/style.css";
import "@tecma/ds/checkbox/style.css";
import "@tecma/ds/checkbox-group/style.css";
import "@tecma/ds/divider/style.css";
import "@tecma/ds/drawer/style.css";
import "@tecma/ds/drop-down/style.css";
import "@tecma/ds/error-page/style.css";
import "@tecma/ds/header/style.css";
import "@tecma/ds/icon/style.css";
import "@tecma/ds/input/style.css";
import "@tecma/ds/language-selector/style.css";
import "@tecma/ds/lazy-image/style.css";
import "@tecma/ds/loader-page/style.css";
import "@tecma/ds/modal/style.css";
import "@tecma/ds/portal/style.css";
import "@tecma/ds/radio/style.css";
import "@tecma/ds/radio-group/style.css";
import "@tecma/ds/select/style.css";
import "@tecma/ds/snackbar/style.css";
import "@tecma/ds/spinner/style.css";
import "@tecma/ds/tag/style.css";
import "@tecma/ds/text-area/style.css";
import "@tecma/ds/tooltip/style.css";
import "styles/main.scss";
import { App } from "App";
import Store from "store/store.js";
import { StoreProvider } from "store/storeUtils.js";
import { ApolloProvider } from "@apollo/client";
import Api from "gqlclient/GraphqlClient";
import { injectContextHeaders } from "@tecma/logs-fe";
import { ErrorBoundary } from "react-error-boundary";
import { DeviceContext } from "@tecma/ds/device-context";
import { ErrorPage } from "@tecma/ds/error-page";
import * as serviceWorker from "./serviceWorker";

injectContextHeaders();
const store = new Store();

//TODO: CHANGE STORE NAME!
const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={() => {
        return (
          <ErrorPage
            logo={`${process.env.REACT_APP_BUCKET_BASEURL}/initiatives/${encodeURI(
              store.loginProjectName,
            )}/global/img/logo192.png`}
            language={
              store?.loggedUser
                ? store.loggedUser.language + "-" + store.loggedUser.locale
                : undefined
            }
          />
        );
      }}
    >
      <StoreProvider value={store}>
        <ApolloProvider client={Api(store)}>
          <DeviceContext>
            <App />
          </DeviceContext>
        </ApolloProvider>
      </StoreProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
